// extracted by mini-css-extract-plugin
module.exports = {"myButton":"HeaderCat_myButton__1Ui_g"};